import './galleyComponent.css'
import React from 'react';
import { VerticalSeparator } from '../components/separators';
import Gallery from '../galleries/gallery.tsx';

function GalleryComponent(props) {

    const { text, DataHousePage1} = props;

  return (
    <div style={{ textAlign: 'center', marginLeft: '12px', marginRight: '12px' }}>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <h1 className='text-h-gallery-class'>{text}</h1>

        <Gallery data={DataHousePage1}></Gallery>

      </div>
  );
}

export default GalleryComponent;